<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="bodymatter" id="rpt1" title="Flock">
<p class="fm1a"><span class="right_1" epub:type="pagebreak" id="page_8" title="8"><span class="right_1" epub:type="pagebreak" id="page_9" title="9"><a href="#/text/Contents#pt1">Flock</a></span></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?3a3470ec